export default Object.freeze({
  GOOGLE_GA_KEY: process.env.VUE_APP_GA_KEY,
  GOOGLE_GAPI_KEY: process.env.VUE_APP_GAPI_KEY,
  GOOGLE_GAPI_CLIENT_ID: process.env.VUE_APP_GAPI_CLIENT_ID,

  MICROSOFT_CLIENT_ID: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
  AUTH_COOKIE: 'matlib-jwt-auth',
});
